import React from 'react'
import { Stack, Typography } from '@mui/material'
import Barcode from 'react-barcode'
import { useTranslation } from 'react-i18next'

const isPresent = (value) => value != null && value !== ''

// The full-width row at the foot of the page: the parcel id drawn as a barcode,
// and the one or two pincodes under it. Shorter than react-barcode's default
// 100px — it is scanned off the screen, which needs the bars' width, not their
// height, and the full height pushed everything else down.
export default function BarcodePart({ parcel }) {
  const { t } = useTranslation('parcels')

  const hasContent =
    parcel.parcelId || isPresent(parcel.pincode) || isPresent(parcel.pincode2)
  if (!hasContent) return null

  return (
    <Stack spacing={1}>
      {parcel.parcelId && (
        <Stack alignItems="center">
          <Barcode value={parcel.parcelId} height={50} />
        </Stack>
      )}
      {isPresent(parcel.pincode) && (
        <Typography align="center">
          {t('pincode')}: {parcel.pincode}
        </Typography>
      )}
      {isPresent(parcel.pincode2) && (
        <Typography align="center">
          {t('pincode2')}: {parcel.pincode2}
        </Typography>
      )}
    </Stack>
  )
}
